export default class ExchangeRateProvider {
    /*
     *   Exchange Rate functions
     */
    async getRate(symbol) {
        const valueString = localStorage.getItem(`rate-${symbol}`);
        if (valueString) {
            return JSON.parse(valueString);
        }
        return undefined;
    }
    async setRate(symbol, rate, ttl) {
        localStorage.setItem(`rate-${symbol}`, JSON.stringify({ symbol: symbol, rate: rate, ttl: ttl }));
        return true;
    }
}
//# sourceMappingURL=ExchangeRateProvider.js.map